import React from "react";
import { Trophy, Newspaper } from "lucide-react";
import { awards, newsArticles } from "../data/mock";

export default function AwardsSection() {
  return (
    <section id="awards" className="relative py-24 px-4 sm:px-6 lg:px-10 bg-brown-gradient grain text-[#FFF8E7] rounded-t-[40px]">
      <div className="max-w-7xl mx-auto relative">
        <div className="flex items-center gap-3 mb-3">
          <Trophy className="w-6 h-6 text-[#FFE357]" />
          <span className="text-xs uppercase tracking-widest font-semibold text-[#FFE357]">Recognition</span>
        </div>
        <h2 className="text-5xl sm:text-6xl font-extrabold tracking-tight">Awards</h2>

        <div className="mt-12 grid sm:grid-cols-2 lg:grid-cols-4 gap-6">
          {awards.map((a) => (
            <div
              key={a.id}
              className="group relative rounded-3xl overflow-hidden border border-white/15 bg-white/5 backdrop-blur-sm hover:bg-white/10 transition-colors"
            >
              <div className="aspect-[4/3] overflow-hidden">
                <img
                  src={a.image}
                  alt={a.title}
                  className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                  loading="lazy"
                />
              </div>
              <div className="p-5">
                <h4 className="text-xl font-bold">{a.title}</h4>
                <p className="text-sm text-white/70 mt-1">{a.subtitle}</p>
              </div>
            </div>
          ))}
        </div>

        <div className="mt-24">
          <div className="flex items-center gap-3 mb-3">
            <Newspaper className="w-6 h-6 text-[#FFE357]" />
            <span className="text-xs uppercase tracking-widest font-semibold text-[#FFE357]">Press</span>
          </div>
          <h2 className="text-5xl sm:text-6xl font-extrabold tracking-tight">In the news</h2>

          <div className="mt-10 grid md:grid-cols-3 gap-6">
            {newsArticles.map((n) => (
              <a
                key={n.id}
                href={n.url}
                target={n.url && n.url !== "#" ? "_blank" : undefined}
                rel={n.url && n.url !== "#" ? "noopener noreferrer" : undefined}
                className="block rounded-3xl bg-[#FFF8E7] text-[#0F0F10] p-6 border-[1.5px] border-[#0F0F10] shadow-[6px_6px_0_#000] hover:shadow-[9px_9px_0_#000] hover:-translate-x-0.5 hover:-translate-y-0.5 transition-all"
              >
                <div className="text-[11px] uppercase tracking-widest font-bold text-red-700 font-mono">
                  {n.publication}
                </div>
                <h4 className="mt-3 text-lg font-bold leading-snug">{n.headline}</h4>
                <p className="mt-3 text-sm text-[#0F0F10]/70 leading-relaxed">{n.excerpt}</p>
                <div className="mt-4 pt-3 border-t border-[#0F0F10]/15 text-xs font-mono text-[#0F0F10]/50">
                  Read article →
                </div>
              </a>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}
